var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.857 0H2.143A2.145 2.145 0 0 0 0 2.143v13.714C0 17.04.961 18 2.143 18h13.714A2.145 2.145 0 0 0 18 15.857V2.143A2.145 2.145 0 0 0 15.857 0Zm-1.712 7.853a3.21 3.21 0 0 1-2.982-1.437v4.944a3.655 3.655 0 1 1-3.654-3.654c.076 0 .15.007.225.011v1.801c-.075-.009-.148-.023-.225-.023a1.865 1.865 0 1 0 0 3.73c1.03 0 1.94-.811 1.94-1.841l.018-8.398h1.72a3.21 3.21 0 0 0 2.958 2.865v2.002Z",
    fill: "#999"
  })));
};
export default SvgTiktok;